const toolTipData = [
  {
    id: "locationId",
    text: "Select Location to Get the All Devices."
  },
  {
    id: "Filter",
    text: "Search by Device Name,Model Name,User Full Name."
  }
];

const tableHeaderData = [
  {
    label: "Location Name",
    place: "bottom",
    type: "locationName",
    toolTipText: "Click for Location Name Sorting"
  },
  {
    label: "Location Type",
    place: "left",
    type: "locationType",
    toolTipText: "Click for Location Type Sorting"
  },
  {
    label: "Location Code",
    place: "left",
    type: "locationCode",
    toolTipText: "Click for Location Code Sorting"
  },
  {
    label: "User Name",
    place: "left",
    type: "workerName",
    toolTipText: "Click for User Name Sorting"
  },
  {
    label: "User Id",
    place: "left",
    type: "workerId",
    toolTipText: "Click for User Id Sorting"
  },
  {
    label: "Number",
    place: "left",
    type: "workerNumber",
    toolTipText: "Click for User Number Sorting"
  },
  {
    label: "Device Name",
    place: "left",
    type: "deviceName",
    toolTipText: "Click for Device Name Sorting"
  },
  {
    label: "Model Name",
    place: "left",
    type: "modelName",
    toolTipText: "Click for Model Name Sorting"
  }
];

export { toolTipData, tableHeaderData };
